module.exports = __webpack_public_path__ + "img/house04.1c4b49f9.jpg";